import React  from 'react';

import Detailed1 from './detailed';
import Detailed2 from './detailed2';

const Details = (props) =>{
    
    if((props.unit) === 'unit'){
        return(
            <Detailed2 currency={props.currency} type={props.type} show={props.show}/>
        );
    }else{
        return(
             <Detailed1 currency={props.currency} type={props.type} show={props.show}/>
           
            
        );
    }
    
}

export default Details;